import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ListingFormDescriptions from './forms/listingFormDescriptions';
import ListingFormDetails from './forms/listingFormDetails';
import ListingFormPhotos from './forms/listingFormPhotos';
import ListingFormAmenities from './forms/listingFormAmenities';
import ListingFormPricing from './forms/listingFormPricing';
import ListingFormPhotosOrder from './forms/listingFormPhotosOrder';
import ListingFormDiscounts from './forms/listingFormDiscounts';
import ListingFormAddOns from './forms/listingFormAddOns';
import ListingFormManageAvailability from './forms/listingFormManageAvailability';
import ListingFormCalendars from './forms/listingFormCalendars';

const mapStateToProps = state => ({
  global:state.Global,
  listings:state.Listing.listingCollection
});

class EditListingComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="container listing-container">
        <h2>Edit your Listing</h2>
        <Route path="/dashboard/listing/edit/details"
          render={() => { return (<ListingFormDetails workflow="edit" parent="dashboard" />) }} />
        <Route path="/dashboard/listing/edit/descriptions"
          render={() => { return (<ListingFormDescriptions workflow="edit" parent="dashboard" />) }} />
        <Route path="/dashboard/listing/edit/amenities"
          render={() => { return (<ListingFormAmenities workflow="edit" parent="dashboard" exit />) }} />
        <Route path="/dashboard/listing/edit/photos"
          render={() => { return (<ListingFormPhotos workflow="edit" parent="dashboard" />) }} />
        <Route path="/dashboard/listing/edit/photosOrder"
          render={() => { return (<ListingFormPhotosOrder workflow="edit" parent="dashboard" exit />) }} />
        <Route path="/dashboard/listing/edit/pricing"
          render={() => { return (<ListingFormPricing workflow="edit" parent="dashboard" exit />) }} />
        <Route path="/dashboard/listing/edit/addons"
          render={() => { return (<ListingFormAddOns workflow="edit" parent="dashboard" exit />) }} />
        <Route path="/dashboard/listing/edit/discounts"
          render={() => { return (<ListingFormDiscounts workflow="edit" parent="dashboard" exit />) }} />
        <Route path="/dashboard/listing/edit/calendars"
          render={() => { return (<ListingFormCalendars workflow="edit" parent="dashboard" exit />) }} />
        <Route path="/dashboard/listing/edit/manageAvailability"
          render={() => { return (<ListingFormManageAvailability workflow="edit" parent="dashboard" exit />) }} />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(EditListingComponent));
